/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown>, name: NonNullable<unknown> }} Vekn_Abandon_ConfirmInputs */



/**
* | output |
* | --- |
* | "This will remove the VEKN ID {id} from {name}'s account, along with all their login methods." |
*
* @param {Vekn_Abandon_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_abandon_confirm = /** @type {((inputs: Vekn_Abandon_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Abandon_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cela retirera le VEKN ID ${i?.id} du compte de ${i?.name}, ainsi que toutes ses méthodes de connexion.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Esto eliminará el ID VEKN ${i?.id} de la cuenta de ${i?.name}, junto con todos sus métodos de inicio de sesión.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Isso removerá o VEKN ID ${i?.id} da conta de ${i?.name}, junto com todos os métodos de login.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo rimuoverà il VEKN ID ${i?.id} dall'account di ${i?.name}, insieme a tutti i suoi metodi di accesso.`)
	return /** @type {LocalizedString} */ (`This will remove the VEKN ID ${i?.id} from ${i?.name}'s account, along with all their login methods.`)
});